import * as React from 'react';
import styled from 'styled-components';
import { FolderId } from 'modules/domains/foldering';
import { link2, colors } from 'ui/theme';
import { hasHorizontalOverflow } from 'utils/elementHelpers';
import { Label } from '../Folders.styles';

export const StyledLink = styled.a`
  ${link2}
  color: ${colors.textPrimary};
  text-decoration-color: transparent;
  font-weight: 400;
`;

export type Props = {
  /** an updated function to alert if the name overflows the container */
  handleOverflow: (arg: boolean) => void;
  /** the folder id */
  id: FolderId;
  /** if this is the last folder */
  isLastFolder?: boolean;
  /** the name of the folder */
  name: string;
  /** Function run when a new folder is selected */
  onSelect: (folderId: FolderId, folderName: string) => void;
};

/**
 * A breadcrumb triggers an optional tooltip
 */
export const FolderName = ({ handleOverflow, id, isLastFolder = false, name, onSelect }: Props) => {
  const myRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (myRef.current) {
      const hasOverflow = hasHorizontalOverflow(myRef.current);
      if (hasOverflow) {
        handleOverflow(hasOverflow);
      }
    }
  }, []);

  return (
    <Label isLastItem={isLastFolder} ref={myRef} isMini>
      {!isLastFolder ? (
        <StyledLink onClick={() => onSelect(id, name)}>{name}</StyledLink>
      ) : (
        <span>{name}</span>
      )}
    </Label>
  );
};
